import { call, put, takeLatest } from "redux-saga/effects";
import { ToastError, ToastSuccess, ToastInfo } from "components/Global/Toasts/Toasty";
import { downloadXLSFile } from "utils/api";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
} from "shared-utility/store/utils/helpers";

// ACTIONS
export const PREPAYMENT_CALCULATOR_RESET_TEST_DATA = generateDefaultActions("PREPAYMENT_CALCULATOR_RESET_TEST_DATA");
export const prepaymentCalculatorResetTestData = payload => makePayload(PREPAYMENT_CALCULATOR_RESET_TEST_DATA.value, payload);
function* prepaymentCalculatorResetTestDataSaga(payload) {
  yield put(PREPAYMENT_CALCULATOR_RESET_TEST_DATA);
}

export const PREPAYMENT_CALCULATOR_DEAL_PREPAYMENT_ANALYSIS = generateDefaultActions("PREPAYMENT_CALCULATOR_DEAL_PREPAYMENT_ANALYSIS");
export const getDealPrepaymentAnalysis = payload => makePayload(PREPAYMENT_CALCULATOR_DEAL_PREPAYMENT_ANALYSIS.value, payload);
function* getDealPrepaymentAnalysisSaga(payload) {
  const url = `/metrics/dealPrepaymentAnalysis?dealId=${payload.dealId}&prepaymentDate=${payload.prepaymentDate}`;
  yield requestSaga(PREPAYMENT_CALCULATOR_DEAL_PREPAYMENT_ANALYSIS, url, "GET");
}

// NOTE: NOT REFERENCED IN REDUCER
export const PREPAYMENT_CALCULATOR_EXPORT_DEAL_PREPAYMENT_RESULTS = generateDefaultActions("PREPAYMENT_CALCULATOR_EXPORT_DEAL_PREPAYMENT_RESULTS");
export const exportDealPrepaymentResults = payload => makePayload(PREPAYMENT_CALCULATOR_EXPORT_DEAL_PREPAYMENT_RESULTS.value, payload);
function* exportDealPrepaymentResultsSaga(payload) {
  const url = "exportDealPrepaymentResults";
  yield call(downloadXLSFile, url, "POST", payload, "");
}

// REDUCER

const initialState = {
  dealPrepaymentAnalysis: null
};

export function prepaymentCalculatorReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case PREPAYMENT_CALCULATOR_RESET_TEST_DATA:
      return {
        ...state,
        ...initialState
      };

    case PREPAYMENT_CALCULATOR_DEAL_PREPAYMENT_ANALYSIS.success:
      return defaultReturn(state, payload.result, "dealPrepaymentAnalysis");

    case PREPAYMENT_CALCULATOR_DEAL_PREPAYMENT_ANALYSIS.failure:
      ToastInfo("Prepayment Analysis Could not be run at this time. Please check your deal settings.");
      console.log("PREPAYMENT_CALCULATOR_DEAL_PREPAYMENT_ANALYSIS.failure", payload);

      return defaultReturn(state, {}, "dealPrepaymentAnalysis");

    default:
      return state;
  }
}

// SAGA

export function* prepaymentCalculatorSaga() {
  yield takeLatest(PREPAYMENT_CALCULATOR_RESET_TEST_DATA.value, prepaymentCalculatorResetTestDataSaga);
  yield takeLatest(PREPAYMENT_CALCULATOR_DEAL_PREPAYMENT_ANALYSIS.value, getDealPrepaymentAnalysisSaga);
  yield takeLatest(PREPAYMENT_CALCULATOR_EXPORT_DEAL_PREPAYMENT_RESULTS.value, exportDealPrepaymentResultsSaga);
}
